<template>
  <c-slider
    v-model="opacity"
    title="Opacity (%)"
    :percent="true"
    :snapTo="0.05"
  >
  </c-slider>
</template>

<script>
// import Component from "../component_location"
import CSlider from "@/components/Core/CSlider.vue";

export default {
  components: { CSlider },

  props: { element: { type: Object, default: () => {} } },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {
    opacity: {
      // GETTER
      get: function() {
        if (this.element.startOpacity && this.element.endOpacity) {
          return {
            start: this.element.startOpacity,
            end: this.element.endOpacity,
          };
        } else {
          return { start: 0.25, end: 0.75 };
        }
      },

      // SETTER
      set: function(opacity) {
        this.element.startOpacity = opacity.start;
        this.element.endOpacity = opacity.end;
      },
    },
  },

  mounted() {},
};
</script>

<style></style>
